import { onLoad } from "@otto-ec/global-resources/dom";
import { onMount } from "svelte";
import { innerHeight } from "svelte/reactivity/window";

export type StuckState = Record<
  "title" | "actions",
  {
    stuck: boolean;
    element: HTMLElement | undefined;
    isStuck: (rect: DOMRect, windowHeight: number) => boolean;
  }
>;

/**
 *
 *
 *
 */
export const useStuckState = (
  reverseLookupMap = new WeakMap<Element, keyof StuckState>(),
): StuckState => {
  const state = $state<StuckState>({
    title: {
      stuck: false as boolean,
      element: undefined as HTMLElement | undefined,
      isStuck: (rect) => rect.top < 0,
    },
    actions: {
      stuck: false as boolean,
      element: undefined as HTMLElement | undefined,
      isStuck: (rect, windowHeight) => rect.bottom > windowHeight,
    },
  });

  /*                                    */
  const observer = new IntersectionObserver(
    /*                                */
    (entries) => {
      entries.forEach(({ target, intersectionRatio }) => {
        /*                                                              */
        state[reverseLookupMap.get(target)!].stuck = intersectionRatio < 1;
      });
    },
    { threshold: [1], root: null },
  );

  /*                                                                             */
  let _$onLoad = $state(false);
  onLoad.sub(() => (_$onLoad = true), { once: true });

  /*                                                         */
  /*                                                                                                                 */
  $effect(() => {
    /*                                                     */
    if (!_$onLoad) return;

    /*                                        */
    const { current: windowHeight = document.documentElement.clientHeight } = innerHeight;

    /*                                                               */
    const elements = Object.entries(state).filter(([, s]) => s.element);

    /*                                          */
    /*                                                                       */
    /*                                                     */
    requestAnimationFrame(() => {
      elements.forEach(([k, s]) => {
        /*                                                                 */
        const element = s.element!;

        /*                          */
        const rect = element.getBoundingClientRect();
        s.stuck = s.isStuck(rect, windowHeight);

        /*                                                              */
        reverseLookupMap.set(element, k);
        /*                                                                                                      */
        observer.observe(element);
      });
    });
  });

  /*                            */
  onMount(() => () => observer.disconnect());

  return state;
};
